var React = require('react');

function ArrowTop (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow-top"),React.createElement("path",{"d":"M237.708 146.332v0l-234.457 233.644c-1.217 1.376-2.297 2.923-3.188 4.586l-0.064 0.13h28.128l227.791-227.628 18.21 18.373 209.743 209.255h28.129c-0.885-1.809-1.971-3.363-3.26-4.724l0.008 0.009-234.294-233.643-18.373-19.023z","key":1})]);
}

ArrowTop.defaultProps = {"version":"1.1","width":"512","height":"512","viewBox":"0 0 512 512"};

module.exports = ArrowTop;

ArrowTop.default = ArrowTop;
